import tippy from 'tippy.js';
import { MOBILE } from '../../assets/scripts/constants';

class Collections {
	constructor(el) {
		this.container = el;
		this.mm = window.matchMedia(MOBILE);
		if (!this.container) return;

		this.items = Array.from(this.container.querySelectorAll('[data-collection-item]'));
		this.button = this.container.querySelector('[data-collection-all]');
		this.hiddenClass = '_is-hidden';

		this.init();
	}

	init() {
		this.initTooltips();
		this.updateHiddenCount();
		this.bindEvents();
	}

	initTooltips() {
		if (this.mm.matches) return;

		this.items.forEach((item) => {
			const content = item.dataset.tooltip;
			if (!content) return;
			this.attachTooltip(item, content, item.dataset.tippyTheme);
		});
	}

	attachTooltip(element, content, theme = 'default') {
		if (this.mm.matches) return;

		const hasSlider = this.container.hasAttribute('data-collection-slider');
		const placementValue = this.container.getAttribute('data-collection-placement');

		tippy(element, {
			content,
			delay: [200, 50],
			offset: [0, 3],
			interactive: hasSlider ? true : false,
			duration: [300, 200],
			allowHTML: true,
			placement: placementValue ? placementValue : 'top',
			theme,
			hideOnClick: false,
		});
	}

	updateHiddenCount() {
		if (!this.button) return;

		const hiddenCount = this.items.filter((item) => item.classList.contains(this.hiddenClass)).length;

		if (hiddenCount > 0) {
			this.button.innerHTML = `<span>+${hiddenCount}</span>`;
			this.button.style.display = '';
		} else {
			this.button.style.display = 'none';
			this.container.parentElement.classList.add('_has-hidden');
		}
	}

	bindEvents() {
		if (!this.button) return;
		this.button.addEventListener('click', () => this.showAll());
	}

	showAll() {
		this.items.forEach((item) => item.classList.remove(this.hiddenClass));
		this.updateHiddenCount();
	}
}

document.querySelectorAll('[data-collection]').forEach((el) => new Collections(el));
export default Collections;
